
export default function getMyUpsolveEntryUrl(fromStudentLoansCTA=false) {
  if (!UPSOLVE_FILER_URL) return ""
  if (fromStudentLoansCTA) return  `${UPSOLVE_FILER_URL}/bankruptcy-screener?fromStudentLoansCTA=true`
  return  `${UPSOLVE_FILER_URL}/bankruptcy-screener`;
}
